module.exports = __webpack_public_path__ + "img/xiaochengxu.723bd0a7.jpg";